module.exports = __webpack_public_path__ + "static/img/2.3a16f2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2.jpg
// module id = rzWQ
// module chunks = 1